import { render, staticRenderFns } from "./SlideScreen.vue?vue&type=template&id=5b5c2a23&"
import script from "./SlideScreen.vue?vue&type=script&lang=js&"
export * from "./SlideScreen.vue?vue&type=script&lang=js&"
import style0 from "./SlideScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports